import { RoomProvider } from '@liveblocks/react'

import { useGetPortalCommentsRoom } from '@/api/assessor-questionnaire.hook'
import { useGetControl } from '@/api/control.hook'
import { Control, RiskQuestionnaireControlThread } from '@/gen/inventory/v1/control_service_pb'

import { ThreadCardContent } from '@/pages/control/risk-questionnaire-thread-card/thread-card-content'
import { ThreadCardWithLiveComments } from '@/pages/control/risk-questionnaire-thread-card/thread-card-with-live-comments'

export type RiskQuestionnaireThreadCardProps = {
  controlStatusId: Control['id']
  thread: RiskQuestionnaireControlThread
  readOnly: boolean
}

export const RiskQuestionnaireThreadCard = (props: RiskQuestionnaireThreadCardProps) => {
  const {
    data: control,
    isPending: controlPending,
    isError: controlFailed,
  } = useGetControl(props.controlStatusId)
  // One comments room per company, shared with the portal. The server derives and
  // returns the room id, creating the room on first use.
  const orgCompanyId = control?.company?.companyId
  const { data, isLoading, isError } = useGetPortalCommentsRoom(orgCompanyId)

  if (data?.roomId) {
    // The Liveblocks client/provider is mounted once by the surrounding ControlTimeline
    // (via TenantCommentsProvider); each card only joins its company room.
    return (
      <RoomProvider id={data.roomId} initialPresence={{}}>
        <ThreadCardWithLiveComments {...props} />
      </RoomProvider>
    )
  }

  // isLoading stays false while the room query is disabled, so a missing company id
  // falls through to the stored activity instead of a skeleton that never resolves.
  if (!controlFailed && !isError && (controlPending || isLoading)) {
    return <ThreadCardContent {...props} liveThreadsPending />
  }

  return <ThreadCardContent {...props} />
}
